export enum Langauge {
  PL = 'pl',
  EN = 'en',
}
